// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".typed-element{display:flex;align-items:center}.typed-element .typed-cursor{opacity:1;animation:typedjsBlink .7s infinite}@keyframes typedjsBlink{50%{opacity:0}}", ""]);
// Exports
module.exports = exports;
